import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, isDevMode} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import {SystemFile} from './../../../shared/models/file.model';

// Environmental Variables
import { environment } from './../../../../environments/environment';


@Component({
  selector: 'app-dbe-rest-report',
  templateUrl: './dbe-rest-report.component.html',
  styleUrls: ['./dbe-rest-report.component.scss']
})
export class DbeRestReportComponent implements OnInit {

  @Input() file_id?: Observable<any[]>;
  @Input() file_data?: any;
  @Input() permission_check?: boolean;
  file: SystemFile;


   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   returned_file_data: Object;
   sessionUserId: any;
   sessionUsername: any;
   sessionBrandId: any;
   all_router_details: string;

   encryptionReportData: any = null;
  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


   }

  ngOnInit(): void {
    // this.loadEncryptionReport()
  }


  loadEncryptionReport() {
    this._demoService.getEncryptionReport().subscribe(
      data => {
        this.encryptionReportData = data;
        this.toastr.success('Encryption report loaded');
      },
      err => {
        console.error(err);
        this.toastr.error('Failed to load encryption report');
      }
    );
  }


}
